module.exports = __webpack_public_path__ + "static/img/male.2b6b2b88.svg";